// VoiceSpectrum.Web.T2 - lib/saveError - v1.0 (12.3.12.5)
// v12.3.12.5 (#334): ONE place that decides what a failed save says.
//
// Found during the 12.3.12.2 browser QA, not reported by Tushar: saving Personalization > Vocabulary showed
// "Could not save - Your changes are still here - try again, or Discard to revert." The payload was correct and
// #314 was not at fault; a fetch trace showed the app's own PUT returning 401 because the JWT had simply expired
// during a long session. "Try again" is the one thing that cannot work after a 401, and every settings section
// said it, because each one hard-coded the same string in its own onError.
//
// Deliberately NOT a redirect to the sign-in page: that would throw away the unsaved edits the toast is telling
// the person are still there. The person signs in again in another tab (or reloads once they have copied
// anything they cannot lose) and their draft is still on screen until they choose to leave.
import { ApiError } from './api';
import { toast } from './toast';

/** True when this rejection is an expired / rejected session rather than a real save failure. */
export function isSessionExpired(err: unknown): boolean {
  return err instanceof ApiError && err.status === 401;
}

/**
 * Show the right toast for a failed save.
 * @param err     whatever the mutation rejected with
 * @param what    what was being saved, in the person's words ("email settings", "your changes")
 */
export function saveErrorToast(err: unknown, what = 'your changes'): void {
  if (isSessionExpired(err)) {
    toast(
      'warning',
      'Your session ended',
      `You have been signed out, so ${what} could not be saved. Sign in again in a new tab - what you typed is still here.`,
    );
    return;
  }
  toast('error', 'Could not save', `${capitalize(what)} are still here - try again, or Discard to revert.`);
}

function capitalize(s: string): string {
  return s.length === 0 ? s : s[0].toUpperCase() + s.slice(1);
}

export default saveErrorToast;
